import { Handle, Position } from 'reactflow';
import { NodeProps } from 'reactflow';
import { BoardingModule } from '../../configLookup/components/Props';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import styles from '../configInfo.module.css';

function ModuleNode({ data }: NodeProps<BoardingModule>) {
  return (
    <div>
      <Handle type="target" position={Position.Top} isConnectable={false} />
      <div>
        <Card className={styles.moduleNode}>
          <CardContent>
            <Typography variant="h4">
              <b>{data.name}</b>
            </Typography>
            <Typography variant="h6">Ordinal: {data.ordinal}</Typography>
          </CardContent>
        </Card>
        <Handle type="source" position={Position.Bottom} isConnectable={false} />
      </div>
    </div>
  );
}

export default ModuleNode;
